<template>
  <div v-loading="loading" class="newyear-page">
    <div class="event">
      <div class="event-head" />
      <div class="content-wrapper">
        <el-row :gutter="0">
          <el-col :span="24">
            <div v-if="itemList.length">
              <el-row v-loading="listLoading" class="list-container">
                <el-col v-for="item in itemList" :key="item.itemId">
                  <div class="item-box">
                    <div class="item-image">
                      <router-link
                        :to="{name: 'item-info', params: {itemId: item.itemId}}"
                        target="_blank"
                        rel="opener"
                      >
                        <img :src="getImageUrl(item)" >
                      </router-link>
                    </div>
                    <div class="item-name ellipsis">
                      <router-link
                        :to="{name: 'item-info', params: {itemId: item.itemId}}"
                        :title="item.itemName"
                        target="_blank"
                        rel="opener"
                      >{{ item.itemName }}</router-link>
                    </div>
                    <div class="item-price">
                      ￥
                      <span v-if="inPromotion(item)" class="price-number">{{ item.promotionPrice }}</span>
                      <span v-else class="price-number">{{ item.itemPrice }}</span>
                    </div>
                    <div class="qita">
                      <div class="item-qty">
                        <el-input-number
                          v-model="item.buyQty"
                          :min="item.minQty"
                          :max="item.maxQty"
                          :step="item.stepQty"
                          size="mini"
                        />
                      </div>
                    </div>
                    <div class="item-buy">
                      <el-button
                        type="default"
                        size="mini"
                        class="buy-btn"
                        @click="addToCart(item)"
                      >加入购物车</el-button>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-else class="no-data">当前没有商品信息</div>
          </el-col>
        </el-row>
      </div>
      <div class="event-rule">
        <div class="event-rule-content">
          <p>活动细则：</p>
          <p class="rule-category">一、参与对象：所有区域及对应的哈冰萃/晶萃一级经销商</p>
          <p class="rule-category">二、活动时间：2020/01/01 – 2020/2/29</p>
          <p class="rule-category">三、活动内容：</p>
          <p>达成销售指标后每1,080箱 (10托) 可兑换一张多利卡 分别有价值1,288元/张、1,588元/张、2,088元/张</p>
          <p class="remark">(仅可购买哈冰萃相关物料)</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import itemApi from "../../api/item"
import baseApi from "../../api/base"
import { commonUtils } from "../../utils/common"
import CategoryMenu from "../item/components/category-menu"
import QueryCondition from "../item/components/query-condition"
export default {
  name: "NewYear",
  components: {
    CategoryMenu,
    QueryCondition
  },
  data () {
    return {
      queryInfo: {
        category: null,
        abiBrand: null,
        priceSection: null,
        keyword: null
      },
      queryParam: {
        abiBrandCode: "HARBINActivity"
      },
      total: null,
      listLoading: false,
      itemList: [],
      loading: false,
      defaultImage: require("../../assets/images/image-not-found.png")
    }
  },

  computed: {
    ...mapGetters(["isDealerClient"])
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.joinActivity()
      this.queryItemList()
    },
    // 商品列表
    queryItemList () {
      this.queryParam.dealerCategoryId = this.queryInfo.category ? this.queryInfo.category.categoryId : ''
      this.queryParam.abiBrandId = this.queryInfo.abiBrand ? this.queryInfo.abiBrand.abiBrandId : ''
      this.queryParam.minPrice = this.queryInfo.priceSection ? this.queryInfo.priceSection.priceFrom : ''
      this.queryParam.maxPrice = this.queryInfo.priceSection ? this.queryInfo.priceSection.priceTo : ''
      this.queryParam.keyword = this.queryInfo.keyword
      this.listLoading = true

      itemApi.queryItemList(this.queryParam).then(response => {
        this.listLoading = false
        if (response.data.resultCode === '0') {
          const itemList = response.data.resultData.itemList
          this.total = response.data.resultData.pageInfo.totalCounts
          itemList.map(item => {
            item.buyQty = item.moqmultiple ? item.moqmultiple : 1
            item.stepQty = item.moqmultiple ? item.moqmultiple : 1
            item.minQty = item.moqmultiple ? item.moqmultiple : 1
            item.maxQty = item.isPreOrder === 1 ? Infinity : (parseInt(item.availableQty / item.stepQty) * item.stepQty)
          })
          this.itemList = itemList
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 获取图片
    getImageUrl (item) {
      let imageUri = ""
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },
    // 促销价
    inPromotion (item) {
      return item.promotionPrice && item.promotionPrice > 0
    },
    // 加入购物车
    addToCart (item) {
      if (item.isPreOrder !== 1 && item.buyQty > item.availableQty) {
        this.$message.error('购买数量超过可售数量')
      }
      if (item.buyQty % item.stepQty !== 0) {
        this.$message.error('购买数量应为订购倍数的整数倍')
        return
      }
      const cartItem = {
        itemId: item.itemId,
        itemQty: item.buyQty
      }
      this.$store.dispatch('AddCartItem', cartItem).then(() => {
        this.$confirm('添加购物车成功,是否转到购物车查看？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        }).then(() => {
          this.$router.push('/cart/list')
        }).catch(() => {
          console.log('cancel opt')
        })
      }).catch(() => {
        this.$message.error('商品添加购物车失败')
      })
    },
    // 判断是否有参与活动的权限
    joinActivity () {
      baseApi.queryBrand().then(response => {
        if (response.data.resultCode === '0') {
          let ecardList = response.data.resultData.ecardList
          if (!ecardList) {
            this.$alert('本活动仅限达成销售指标的经销商参与', '提示', {
              confirmButtonText: '确定',
              callback: () => {
                this.$router.push('/item/list')
              }
            })
          }
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
$color: #fbc42d;

.el-col-24 {
  /* width: 100%; */
  width: auto;
}
.newyear-page {
  width: 100%;
  min-height: 600px;
  height: 100%;
  padding: 0 0 30px 0;
  background-color: #fff;
  background-size: cover;

  .event {
    width: 1200px;
    margin: 0 auto;
    background-image: url('../../assets/images/event/HARBINActivity-bg.jpg');
    background-repeat: no-repeat;
    background-size: 1200px auto;
    background-position: left top;
    line-height: 60px;
    font-size: 1.6rem;
    color: #fff;
    text-align: center;
  }

  .event-head {
    height: 748px;
  }

  .content-wrapper {
    width: 80%;
    margin: 50px auto;
    padding: 0;
    display: flex;
    justify-content: center;
  }

  .list-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    .item-box {
      width: 261px;
      height: 404px;
      margin: 23px;
      overflow: hidden;
      vertical-align: middle;
      text-align: center;
      background: #fff;
      font-size: 17.5px;
      border: 6px solid $color;
      border-radius: 6px;
      color: $color;

      .item-image {
        width: 210px;
        height: 181px;
        margin: 32.5px auto 10px auto;
        overflow: hidden;
        vertical-align: middle;
        img {
          width: auto;
          height: 100%;
          margin: auto;
        }
      }

      .item-name {
        line-height: initial;
        a {
          font-size: 17.5px;
          color: $color;
        }
      }

      .item-price {
        line-height: initial;
        color: #eb302e;
        font-size: 22.5px;
        padding: 5px 0 5px 0;
        .price-number {
          font-size: 22.5px;
        }
      }

      .item-buy {
        padding-top: 8.5px;
        line-height: 0;
        .buy-btn {
          background-color: $color;
          color: #fff;
          border: 0px;
          width: 117px;
          height: 32px;
          border-radius: 25px;
          font-size: 17.5px;
        }
        .buy-btn:focus {
          outline: none;
          border: 0px;
        }
      }
    }
  }

  .event-rule {
    font-size: 15px;
    .event-rule-content {
      padding-bottom: 30px;
      text-align: left;
      line-height: 4px;
      padding-left: 220px;
      .remark {
        padding-top: 26.2px;
      }
    }
  }
}
</style>
